import { render, staticRenderFns } from "./RestaList.vue?vue&type=template&id=4ea6c428&scoped=true&"
import script from "./RestaList.vue?vue&type=script&lang=js&"
export * from "./RestaList.vue?vue&type=script&lang=js&"
import style0 from "./RestaList.vue?vue&type=style&index=0&id=4ea6c428&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea6c428",
  null
  
)

export default component.exports